<template>
  <div>
    <defaultHeader :navIndex="2"></defaultHeader>
    <mobileHeader></mobileHeader>
    <boxTitle :titleIndex="3" :imgUrl="imgUrl" :imgTitle="imgTitle"></boxTitle>
    <div class="news">
      <div class="news-box">
        <div class="news-item" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
          <div class="time">{{ item.createTime }}</div>
          <div class="title">{{ item.articleTitle }}</div>
          <div class="text">{{ item.articleAbstract }}</div>
          <div class="more">查看更多 ></div>
        </div>
      </div>
      <div class="news-box-mobi">
        <div class="news-box-mobi-item" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
          <div class="news-img"><img :src="item.articleImg" /></div>
          <div class="right">
            <div class="title">{{ item.articleTitle }}</div>
            <p class="text">{{ item.articleAbstract }}</p>
            <div class="eyes"><img src="../../static/images/eyes.png" />0</div>
          </div>
        </div>
      </div>
      <template v-if="count">
        <mopaging :page-index="currentPage" :total="count" :page-size="pageSize" @change="pageChange"> </mopaging>
      </template>
    </div>
    <goBack></goBack>
    <defaulFooter></defaulFooter>
  </div>
</template>

<script>
import {articleList, menuList} from '@/api/xx-index'
import {infoList} from '@/api/index'
import defaultHeader from '../components/defaultheader.vue'
import mobileHeader from '../components/mobileheader.vue'
import defaulFooter from '../components/defaulfooter.vue'
import boxTitle from '../components/boxTitle.vue'
import mopaging from '@/components/mopaging'
import goBack from '@/components/goBack'
export default {
  components: {
    defaultHeader,
    defaulFooter,
    boxTitle,
    mobileHeader,
    mopaging,
    goBack
  },
  name: 'news',
  data() {
    return {
      menuIds: '',
      list: [],
      count: '',
      currentPage: 1,
      pageSize: 9,
      imgUrl: '',
      imgTitle: ''
    }
  },
  created() {
    console.log('这是传过来的id', window.location.href.split('=')[1])
    this.menuIds = window.location.href.split('=')[1]
    this.articleListx(this.menuIds)
    //公司基本信息数据
    infoList({deptId: 112}).then(res => {
      // console.log('公司基本信息', res)
      document.title = '新闻资讯-' + res.companyName + '-' + res.websiteDesc
    })
    menuList({
      deptId: 112
    }).then(res => {
      console.log('这是数据1', res)
      for (let i = 0; i < res.length; i++) {
        if (Number(res[i].id) == Number(this.menuIds)) {
          this.imgUrl = res[i].menuBgimg
          this.imgTitle = res[i].menuBgimgTitle
        }
      }
    })
  },
  methods: {
    //列表数据
    articleListx(menuIds) {
      let param = {
        deptId: 112,
        menuIds: menuIds,
        pageNum: this.currentPage,
        pageSize: 9
      }
      articleList(param).then(res => {
        console.log('数据数据', res)
        this.count = res.total
        this.list = res.list
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].createTime = this.list[i].createTime.substring(0, 10)
        }
      })
    },
    //详情
    toDetail(id) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: id
        }
      })
    },
    //分页
    pageChange(page) {
      this.currentPage = page
      //this.loadList();
      this.getList()
    }
  }
}
</script>

<style></style>
